<template>
	<div
	v-if="searchTerm.length > 0 && isDataAvailable"
	class="st-drop-result">
		<!-- Number of Posts -->
		<p class="count-result" v-if="Array.isArray(filteredResults) && filteredResults.length">
			{{this.stringResult}} {{ filteredResults.length }}
		</p>
		<p v-else class="count-result">
			{{ filteredResults }}
		</p>
		<div class="card-group" v-if="Array.isArray(filteredResults) && filteredResults.length">
			<!-- AppDisplayPost Component -->
			<app-display-post
			v-for="postType in filteredResults"
			:key="postType.ID"
			:search-term="searchTerm"
			:post-type="postType"
			role="article" >
			<!-- AppDisplayPost is called for each post in the filteredResults -->
			</app-display-post>

		</div><!-- .card-group -->
	</div><!-- .container -->
	<div v-else-if="searchTerm.length < 1"></div>
	<div v-else>
		<p
		class="apiResponse text-center"
		v-html="apiResponse" />
	</div>
	
</template>

<script>
import axios from 'axios';
import AppDisplayPost from './AppDisplayPost';

export default {
	components: {
		'app-display-post': AppDisplayPost
	},
	props: {
		searchTerm: {
			type: String,
			default: ''
		},
		textResult: {
			type: String,
			default: ''
		},
		route: {
			type: String,
			default: 'get-item-service'
		},
		timing: null,
		waitingSearch: false
	},
	data() {
		/*global wpData:true*/
		/*eslint no-undef: "error"*/

		return {
			apiResponse: '', // initial loading or error messages.
			wpPosts: [], // REST API response data goes here.
			wpData, // global data made available via wp_localize_script.
			isDataAvailable: false
		};
	},
	computed: {
		
		// computed property to get filtered data based on search key or category filter.
		filteredResults() {
			if ( this.wpPosts.data ) {
				// match keyword against post titles or excerpts.
				const pattern = new RegExp( this.searchTerm, 'i' );
				console.log(this.wpPosts.data);
				return this.wpPosts.data;
			}
		},
		stringResult(){
			if ( this.wpPosts.notice ) {
				return this.wpPosts.notice;
			}
		}
	},
	watch: {
		searchTerm: function (newQuestion, oldQuestion) {
			console.log('test', this.searchTerm)
			this.isDataAvailable = false;
			this.fetchData();
			if(this.searchTerm.length < 1){
				this.isDataAvailable = false;
			}
		}
	},
	mounted() {

		// get posts from the WordPress REST API on component creation.
		
	},
	beforeUnmount() {
		clearTimeout(this.timing)
	},
	methods: {

		// fetch posts only if fetchNow is greater than 0.
		fetchData() {
			this.getPosts( this.route, this.searchTerm );
			this.apiResponse = ' Loading ⏳ ';
		},
		async getPosts( route = 'get-item-service', search='',namespace = 'traveler/v1' ) {
			try {
				//http://localhost/goya/wp-json/wc/v3/products?search=product
				/* Note: the per_page argument is capped at 100 records by the REST API.
				 * https://developer.wordpress.org/rest-api/using-the-rest-api/pagination/
				 */

				const postsPerPage = 1; // default is 10.
				const restURL = this.wpData.rest_url;
				const fields = 'id,title,link,vue_meta'; // retrieve data for specific fields only

				// send an initial request and await the response to get the total number of posts.
				const response = await axios(
					`${restURL}/${namespace}/${route}?search=${search}&service=st_hotel`,
				);

				// since partial data is already available from this response, make it available.
				this.wpPosts = response.data;
				if(this.searchTerm.lenght < 1){
					this.isDataAvailable = false;
				} else {
					this.isDataAvailable = true;
				}
				
				

				/*
				 * calculate total number of required API requests using the header fields from the response.
				 *
				 * headers['x-wp-total']: Total WordPress Posts
				 * headers['x-wp-totalpages'] Total number of pages based on the per_page param.
				 */
				const wpTotalPages = Math.ceil(
					response.headers['x-wp-total'] / postsPerPage
				);

				// check & get additional posts but restrict to 1000 posts when per_page is 100. Modify as required.
				const promises = [];
				for ( let page = 2; page <= wpTotalPages && 10 >= page; page++ ) {

					// save the promise returned by the axios requests.
					promises.push(
						axios(
							`${restURL}/${namespace}/${route}?search=${search}&service=st-hotels`
						)
					);
				}

				/*
				 * Await all promises to return before rendering the data.
				 * This also ensures that the response is in the same order in which the requests were made.
				 */
				const wpData = await Promise.all( promises );
				wpData.map( post => this.wpPosts.push( ...post.data ) );
			} catch ( error ) {
				this.apiResponse = ` The request could not be processed! <br> <strong>${error}</strong> `;
			}
		}
	}
};
</script>
<style scoped>
.st-drop-result > .count-result{
	font-size: 16px;
}
.apiResponse{
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		right: 50%;
		margin-bottom: 0px;
	}
</style>



// WEBPACK FOOTER //
// src/components/AppGetPosts.vue